import React from "react"
import {EMISSAO_V2_PAGE, EMPRESAS_V2_PAGE} from "../../../../utils/routes"
import { ReactComponent as PlayIcon } from "../../../assets/icons/play-icon.svg"
import { ArrowForwardIos } from "@mui/icons-material"

export const EMISSION_TITLE =
    {
        name: "Emissão",
        to: EMISSAO_V2_PAGE,
        id: "menu_data_lake_emissao",
        icon: <ArrowForwardIos />,
    }


export const COMPANY_TITLE =
    {
        name: "Empresas",
        to: EMPRESAS_V2_PAGE,
        id: "menu_data_lake_empresas",
        icon: <ArrowForwardIos />,
    }


export const CURVE_TITLE =
    {
        name: "Curvas",
        to: "",
        id: "menu_curvas",
        icon: <ArrowForwardIos />,
    }

export const EMISSION = [
    {
        icon: <PlayIcon />,
        name: "Apresentação",
        id: "emission-presentation",
        to: "",
    },
]

export const COMPANY = [
    {
        icon: <PlayIcon />,
        name: "Apresentação",
        id: "company-presentation",
        to: "",
    },
]

export const CURVE = [
    {
        icon: <PlayIcon />,
        name: "Apresentação",
        id: "curve-presentation",
        to: "",
    },
]
